import React from 'react';
import styled from 'styled-components';
import T from 'components/common/text/T';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import { useShallowAppSelector } from 'store/hooks';
interface ListEmptyProps {
  text?: string;
  isRefreshButton?: boolean;
  onRefresh?: () => void;
}

/**
 * @param {ListEmptyProps}
 * @return {*}
 */
function ListEmpty({ text = '', isRefreshButton = false, onRefresh }: ListEmptyProps) {
  const { t } = useTranslation();

  return (
    <StyledListEmpty data-component-name="ListEmpty">
      <span>{t(`${text}`)}</span>
      {!!isRefreshButton && (
        <IconButton className="listEmpty__refresh" onClick={onRefresh}>
          <T>GLOBAL_REFRESH</T>
        </IconButton>
      )}
    </StyledListEmpty>
  );
}

const StyledListEmpty = styled.section<{}>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 20px;
  .listEmpty__refresh {
    height: 24px;
    border: 1px solid #ccccd4;
    border-radius: 4px;
    font-size: 14px;
    color: #444444;
  }
`;

export default React.memo(ListEmpty);
